import { gsap } from "gsap";
import { NumberUtil } from "../number/NumberUtil";
/**
 * Delay.ts
 *
 * Uses GSAP to queue a callback after a delay.
 *
 * @see {@link https://greensock.com/docs/v3/GSAP/gsap.delayedCall()}
 *
 * By not using promises navigating the call stack is harder.
 */
export class Delay {
    /**
     * @param delayInMs - Time in milliseconds
     * @param handler - Function
     * @param scope - `this` context for `handler`
     * @param args - Arguments to be passed to `handler`
     */
    constructor(delayInMs, handler, scope, args) {
        this.delayInMs = delayInMs;
        this.handler = handler;
        this.scope = scope;
        this.args = args;
        this.createCallDelay();
    }
    /**
     * Constructor for Delay.
     *
     * @param delayInMs - Time in milliseconds
     * @param handler - Function
     * @param scope - `this` context for `handler`
     * @param args - Arguments to be passed to `handler`
     * @returns `this`
     */
    static create(delayInMs, handler, scope, args) {
        return new Delay(delayInMs, handler, scope, args);
    }
    createCallDelay() {
        const delayInSeconds = NumberUtil.round(this.delayInMs / 1000);
        this.tween = gsap.delayedCall(delayInSeconds, Delay.handleComplete, [
            this,
        ]);
    }
    static handleComplete(delay) {
        delay.complete();
    }
    /**
     * Immediately call the handler then `dispose()`.
     */
    complete() {
        this.handler.call(this.scope, this.args);
        this.dispose();
    }
    /**
     * Cancel the timer and remove references.
     */
    dispose() {
        if (this.tween) {
            this.tween.kill();
            this.tween = null;
        }
        this.handler = null;
        this.scope = null;
        this.args = null;
    }
    /**
     * Returns true if the tween is active.
     * @see {@link https://greensock.com/docs/v3/GSAP/Tween/isActive()}
     */
    isActive() {
        return this.tween && this.tween.isActive();
    }
}
//# sourceMappingURL=Delay.js.map